import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleGreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 76,
	height: 76,
	viewBox: "0 0 76 76",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38Z",
			fill: "#DFFCF1"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 38,
			cy: 38,
			r: 32,
			fill: "#22A06B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.75 37.005V38.5C54.748 42.0042 53.6133 45.4139 51.5152 48.2205C49.417 51.0271 46.4678 53.0803 43.1075 54.0739C39.7471 55.0674 36.1555 54.9481 32.8685 53.7337C29.5815 52.5193 26.7751 50.2749 24.8678 47.3353C22.9606 44.3956 22.0547 40.9181 22.2852 37.4215C22.5158 33.9249 23.8705 30.5966 26.1472 27.9328C28.4239 25.269 31.5008 23.4125 34.9188 22.6403C38.3368 21.868 41.9129 22.2213 45.1138 23.6475",
			stroke: "white",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.75 25.5L38.5 41.7663L33.625 36.8913",
			stroke: "white",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCheckCircleGreen;
